import type { GroupedTask, MinifiedTask } from '@gcv/shared';

import { isGroupedTask } from '../../tasks/tasks.model';

/**
 * Merges updated tasks into a cached list, reaching into groups. Updates are merged rather than
 * swapped in so fields the update response omits — `internal_or_external`, say — survive.
 */
export const getTasksWithUpdates = <T extends MinifiedTask | GroupedTask>(
  tasks: T[],
  updatedTasks: MinifiedTask[]
): T[] => {
  const updatesById = new Map(updatedTasks.map((task) => [task.id, task]));

  const applyUpdate = (task: MinifiedTask) => {
    const update = updatesById.get(task.id);
    return update ? { ...task, ...update } : task;
  };

  return tasks.map((task) =>
    isGroupedTask(task) ? { ...task, tasks: task.tasks.map(applyUpdate) } : applyUpdate(task)
  ) as T[];
};
